<template>
  <div>
    <table class="table table-borderless">
      <thead>
        <tr>
          <th>{{ i18n.app.common.fields.cost_determination }}</th>
          <th>{{ i18n.app.common.fields.insurer }}</th>
          <th>{{ i18n.app.common.fields.driver }}</th>
          <th>{{ i18n.app.common.fields.lease_company }}</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="costDetermination in chargeTypesFiltered"
          v-bind:key="costDetermination.id + '-' + costDetermination.id"
          :id="'cost-determination-' + costDetermination.id"
        >
          <td :class="disabled && 'disabled'">
            <div
              :class="errors && errors[`cost_determinations.${costDetermination.id}.selection`] ? {error: true} : {}"
            >{{ costDetermination.name }}</div>
            <div v-if="costDetermination.description">
              <small>{{ costDetermination.description }}</small>
            </div>
          </td>
          <td v-for="type in (costDetermination.selection_types || [CostDeterminationSelection.INSURER, CostDeterminationSelection.CUSTOMER])" :key="type">
            <RadioButton
              :name="`cost_determinations.${costDetermination.id}.selection`"
              :model="model[costDetermination.id]"
              :modelAttribute="'selection'"
              :value="type"
              @change="onChange"
              :required="false"
              :disabled="disabled || (enabledSelectionTypes && !enabledSelectionTypes.includes(type))"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { FormControl, RadioButton } from "@/components/common/form/";
import {
  CostDeterminationSelection,
  ContractCostDeterminationType,
  COST_DETERMINATION_SELECTIONS
} from "@/models/ContractCostDetermination";

export default {
  name: "contract-cost-determinations-edit",
  props: ["name", "model", "disabled", "costDeterminations", "errors", "enabledSelectionTypes"],
  components: {
    FormControl,
    RadioButton
  },
  data() {
    return {
      COST_DETERMINATION_SELECTIONS: COST_DETERMINATION_SELECTIONS,
      CostDeterminationSelection: CostDeterminationSelection,
      chargeTypesFiltered: this.costDeterminations.filter(
        item => item.type !== ContractCostDeterminationType.CAR_PICK_UP
      )
    };
  },
  mounted() {
    this.$emit("mounted");
  },
  updated() {},
  methods: {
    onChange(value) {
      this.$emit("change", value);
    },
    setAll(value) {
      this.costDeterminations.forEach((ct, i) => {
        if (this.model[ct.id] && this.model[ct.id].locked) {

        } else {
          this.model[ct.id] = {
            selection: value
          };
        }
      });
    }
  }
};
</script>
